import moment from "moment";
import { FamilyGroup, Modality } from "../Services/RVEOService";
import { RVEOFormFamilyMember, RVEOFormModality } from "../interfaces/rveoForm";

// Funciones de formateo
export const parseCurrency = (formattedValue: any) => {
  const cleanedValue = formattedValue.replace(/[^0-9.-]+/g, "");
  return parseFloat(cleanedValue);
};

export const formatCurrencySummation = (value: number | string): number => {
  return typeof value === "string" ? parseCurrency(value) : Number(value) || 0;
};

// Transformación de datos para Grupo Familiar
export const transformDataGF = (
  data: RVEOFormFamilyMember[]
): FamilyGroup[] => {
  const dataUpdated: FamilyGroup[] = [];

  data.forEach((element: RVEOFormFamilyMember) => {
    dataUpdated.push({
      sano: element.sano,
      fechaNacimiento: element.bornDate
        ? moment(element.bornDate, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "",
      parentesco: element.relationship,
      genero: element.genrerBenefiarie,
    });
  });

  return dataUpdated;
};

// Transformación de datos para Modalidades
export const transformDataMO = (data: RVEOFormModality[]): Modality[] => {
  const dataUpdated: Modality[] = [];

  data.forEach((element: RVEOFormModality) => {
    dataUpdated.push({
      position: String(element.id),
      diferido: element.defYearsMod,
      garantizado: element.guarYearsMod,
      anosTemporales: element.tempYearsMod,
      moneda: element.currencyMod,
      modalidad: element.modalities,
    });
  });

  return dataUpdated;
};

export const formatCurrency = (value: any) => {
    return new Intl.NumberFormat("es-PE", {
      style: "currency",
      currency: "PEN",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };


export const getObjSendFormValue = (objSendForm: any, key: string, defaultValue: any) => {
  if (objSendForm && objSendForm[key] !== undefined && objSendForm[key] !== null) {
    return objSendForm[key];
  }
  return defaultValue;
}